import { Routes, Route, Navigate } from 'react-router-dom';
import MainLayout from './components/layout/MainLayout';
import Landing from './pages/Landing';
import Login from './pages/Login';
import ReadinessAssessment from './pages/ReadinessAssessment';
import ReadinessAssessmentWizard from './pages/ReadinessAssessmentWizard';
import ReadinessAssessmentDashboard from './pages/ReadinessAssessmentDashboard';
import { ROUTES } from './config/routes';
import { AssessmentProvider } from './contexts/AssessmentContext';
import Index from './pages/Index';
import AssessmentSteps from './features/LegacyBenchmarksUI/components/AssessmentSteps';
import PermitBenchmarking from './features/LegacyBenchmarksUI/pages/PermitBenchmarking';
import PermitBenchmarkingWizard from './features/LegacyBenchmarksUI/pages/PermitBenchmarkingWizard';
import { LayoutProvider } from './contexts/LayoutContext';
import { NewBenchmarksUI } from '@/features/NewBenchmarksUI/NewBenchmarksUI';

function App() {
  return (
    <LayoutProvider>
      <Routes>
        <Route path={ROUTES.HOME} element={<MainLayout><Landing /></MainLayout>} />
        <Route path={ROUTES.LOGIN} element={<Login />} />
        
        {/* Redirect from /readiness-assessment to the proper route */}
        <Route 
          path="/readiness-assessment" 
          element={<Navigate to={ROUTES.READINESS_ASSESSMENT.ROOT} replace />} 
        />
        
        {/* Opportunity Assessment routes with AssessmentProvider */}
        <Route path={ROUTES.OPPORTUNITY_ASSESSMENT.ROOT} element={
          <AssessmentProvider>
            <MainLayout>
              <Index />
            </MainLayout>
          </AssessmentProvider>
        } />
        <Route path={ROUTES.OPPORTUNITY_ASSESSMENT.WIZARD} element={
          <AssessmentProvider>
            <MainLayout>
              <AssessmentSteps />
            </MainLayout>
          </AssessmentProvider>
        } />
        
        {/* Readiness Assessment routes with AssessmentProvider */}
        <Route path={ROUTES.READINESS_ASSESSMENT.ROOT} element={
          <AssessmentProvider>
            <MainLayout><ReadinessAssessment /></MainLayout>
          </AssessmentProvider>
        } />
        <Route path={ROUTES.READINESS_ASSESSMENT.WIZARD} element={
          <AssessmentProvider>
            <MainLayout><ReadinessAssessmentWizard /></MainLayout>
          </AssessmentProvider>
        } />
        <Route path={ROUTES.READINESS_ASSESSMENT.DASHBOARD} element={
          <AssessmentProvider>
            <MainLayout><ReadinessAssessmentDashboard /></MainLayout>
          </AssessmentProvider>
        } />

        {/* Permit Benchmarking routes */}
        <Route path={ROUTES.PERMIT_BENCHMARKING.ROOT} element={
          <MainLayout>
            <NewBenchmarksUI />
          </MainLayout>
        } />
        <Route path={ROUTES.PERMIT_BENCHMARKING.WIZARD} element={
          <MainLayout>
            <PermitBenchmarkingWizard />
          </MainLayout>
        } />
        {/* Legacy Benchmarking UI (internal only) */}
        <Route path={ROUTES.PERMIT_BENCHMARKING.LEGACY} element={
          <MainLayout>
            <PermitBenchmarking />
          </MainLayout>
        } />
      </Routes>
    </LayoutProvider>
  );
}

export default App;